;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import profilePic1 from "./images/profile-pic-1.jpeg"
import profilePic2 from "./images/profile-pic-2.jpeg"
import profilePic3 from "./images/profile-pic-3.jpeg"
import profilePic4 from "./images/profile-pic-4.jpeg"

export const TESTIMONIAL_QUOTES = [
  {
    name: "Alexandre McKing, Fashion Coach",
    quote: `I'd love my fashion coaching group to be considered by therapists for
    clients exploring how to embody their sense of self-expression! I'm
    excited that posting to ZestLife could make this more possible!`,
    title: "Coaches",
    picture: profilePic1,
  },
  {
    name: "Ru Zhang, Psychoanalyst",
    quote: `​In my Hearts On Sleeve teens therapy group, I work closely with providers of any teen also in 1-to-1 mentorship. I'm consistently blown away by how collaborative care can illuminate our teens' reality and help clients reach their goals. I share ZestLife's vision of increasing complimentary care.`,
    title: "Therapists",
    picture: profilePic2,
  },
  {
    name: "Layla Yılmaz, LMSW",
    quote: `I have a full practice and don't want to turn people away without offering options for immediate assistance. When people are seeking help, I know they need it right away. I'd love to refer people to groups on ZestLife!`,
    title: "Social Workers",
    picture: profilePic3,
  },
  {
    name: "Kasey Coastal, Hypnotherapist",
    quote: `As an alternative mental wellness intuitive, I'm often looking for complementary care referals for clients seeking more nervous system regulation practice. Their budgets are limited in terms of adding 1-to-1 support, however; referals to group workshop series via ZestLife would be incredible to assist our work!`,
    title: "Healers",
    picture: profilePic4,
  },
]

export const PICTURES_PAGE_0 = [
  TESTIMONIAL_QUOTES[0].picture,
  TESTIMONIAL_QUOTES[1].picture,
  TESTIMONIAL_QUOTES[2].picture,
  TESTIMONIAL_QUOTES[3].picture,
]
export const PICTURES_PAGE_1 = [
  TESTIMONIAL_QUOTES[1].picture,
  TESTIMONIAL_QUOTES[2].picture,
  TESTIMONIAL_QUOTES[3].picture,
  TESTIMONIAL_QUOTES[0].picture,
]
export const PICTURES_PAGE_2 = [
  TESTIMONIAL_QUOTES[2].picture,
  TESTIMONIAL_QUOTES[3].picture,
  TESTIMONIAL_QUOTES[0].picture,
  TESTIMONIAL_QUOTES[1].picture,
]
export const PICTURES_PAGE_3 = [
  TESTIMONIAL_QUOTES[3].picture,
  TESTIMONIAL_QUOTES[0].picture,
  TESTIMONIAL_QUOTES[1].picture,
  TESTIMONIAL_QUOTES[2].picture,
]
